<template>
  <div class="package-option package-option--alt-gradimages option-frame-product">
    <div class="row">
      <div class="col-xs-8 col-md-9">
        <div class="row">
          <div class="col-xs-12 col-sm-8">
            <h3 class="toggle-button__title">{{ packageOptionProduct.ProductRetailName }}</h3>
          </div>
          <div class="hidden-xs hidden-sm col-sm-4 text-right">
            <div class="config-selection__price config-selection__price--alt-gradimages">
              <option-cost
                :package-base-cost="offerPackage.EffectiveCost"
                :cost="packageOptionProduct.Cost"
                :show-as-total="packageOptionProduct.ShowAsTotal"
                :is-per-frame="isPerFrame"
              />
            </div>
          </div>
        </div>
        <div class="row visible-xs visible-sm">
          <div class="col-xs-12">
            <div class="config-selection__price">
              <option-cost
                :package-base-cost="offerPackage.EffectiveCost"
                :cost="packageOptionProduct.Cost"
                :show-as-total="packageOptionProduct.ShowAsTotal"
                :is-per-frame="isPerFrame"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-4 col-md-3">
        <div class="toggle-button-wrapper">
          <button
            v-if="!isAdded"
            type="button"
            class="button toggle-button__button"
            @click="handleAddClick"
          >
            <span >
              <i
                class="fa fa-plus"
                aria-hidden="true"
              />
              <span>Add</span>
            </span>
          </button>
          <button
            v-if="isAdded"
            type="button"
            class="button toggle-button__button"
            @click="handleRemoveClick"
          >
            <span>
              <i
                class="fa fa-remove"
                aria-hidden="true"
              />
              <span>Remove</span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div
          v-for="(i, frameSlotIndex) in frameSlots"
          :key="frameSlotIndex"
          class="col-xs-3"
        >
          <img
            v-if="moreThanOneFrameSlot && !frameSlots[frameSlotIndex]"
            :src="selectionPlaceHolderImg"
            class="responsive-img option-frame-product__placeholder-image"
            @click="handleImagePlaceholderClick(frameSlotIndex)"
          >
          <img
            v-if="frameSlots[frameSlotIndex]"
            :src="frameSlots[frameSlotIndex].Urls.SmallWatermarked"
            class="responsive-img  option-frame-product__selected-image"
            @click="handleImagePlaceholderClick(frameSlotIndex)"
          >
        </div>
      </div>
    </div>
    <input
      v-if="isAdded"
      :name="packageOptionInputName"
      :value="packageOptionInputValue"
      type="hidden"
    >
    <input
      v-if="isAdded"
      :name="selectedFramesInputName"
      :value="selectedFramesInputValue"
      type="hidden"
    >
    <select-photo-modal
      :show="showSelectPhotoModal"
      @close="showSelectPhotoModal = false"
      @photo-selected="handlePhotoSelected"
    />
  </div>
</template>

<script>
import OptionCost from './OptionCost'
import selectionPlaceHolderImg from '@Shared/img/selection-placeholder.png'
import SelectPhotoModal from '@Shared/components/catalog/SelectPhotoModal/SelectPhotoModal'

export default {
  name: 'PackageOptionFrameProduct',
  components: {
    OptionCost,
    SelectPhotoModal
  },
  props: {
    isPerFrame: { type: Boolean, default: false, required: true },
    packageOptionId: { type: Number, default: null, required: true },
    packageOptionProduct: { type: Object, default: null, required: true }
  },
  data () {
    return {
      selectionPlaceHolderImg,
      frameSlots: [],
      showSelectPhotoModal: false,
      activePlaceholderIndex: null
    }
  },
  computed: {
    offerPackage () {
      return this.$store.state.catalogPageCommon.offerPackage
    },
    imageNoun () {
      return (this.packageOptionProduct.FramesRequired > 1) ? 'images' : 'image'
    },
    isAdded () {
      return this.frameSlots.length === this.packageOptionProduct.FramesRequired
    },
    moreThanOneFrameSlot () {
      return this.packageOptionProduct.FramesRequired > 1
    },
    packageOptionInputName () {
      return `OptionProductIDForPackageOption_${this.packageOptionId}`
    },
    packageOptionInputValue () {
      return this.packageOptionProduct.CatalogPackageOptionProductID
    },
    selectedFramesInputName () {
      return `SelectedFrameIDsForCatalogOptionProduct_${this.packageOptionProduct.CatalogPackageOptionProductID}`
    },
    selectedFramesInputValue () {
      let result = []

      this.frameSlots.forEach(fs => {
        result.push(fs.FrameID)
      })

      return result.join(',')
    }
  },
  watch: {
    showSelectPhotoModal (v, ov) {
      if (v === false) {
        this.activePlaceholderIndex = null
      }
    },
    isAdded (v, ov) {
      if (v !== ov) {
        if (v === true) {
          this.$store.commit('addSelectedOptionProduct', this.packageOptionProduct)
        } else {
          this.$store.commit('removeSelectedOptionProduct', this.packageOptionProduct)
        }
      }
    }
  },
  methods: {
    handleAddClick () {
      this.handleImagePlaceholderClick(0)
    },
    handleRemoveClick () {
      this.frameSlots = []
    },
    handleImagePlaceholderClick (imagePlacholderIndex) {
      this.activePlaceholderIndex = imagePlacholderIndex
      this.showSelectPhotoModal = true
    },
    handlePhotoSelected (selectedPhoto) {
      this.frameSlots.splice(this.activePlaceholderIndex, 1, selectedPhoto.frameInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.option-frame-product {
  &__select-image-title {
    font-size: 16px;
    font-weight: bold;
  }

  &__selected-image,
  &__placeholder-image {
    border: 1px solid #ccc;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/PackageOption/PackageOptionFrameProduct.vue